const clickCopyEvent = async(text) => {
    try {
        await navigator.clipboard.writeText(text)
        return true;
    } catch (error) {
        return false;
    }
};
export default clickCopyEvent;